// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * fps-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: local
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartnerInfoAPIModel
 */
export interface PartnerInfoAPIModel {
    /**
     * 
     * @type {string}
     * @memberof PartnerInfoAPIModel
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerInfoAPIModel
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerInfoAPIModel
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerInfoAPIModel
     */
    returnUrl: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerInfoAPIModel
     */
    callbackUrl: string;
    /**
     * 
     * @type {number}
     * @memberof PartnerInfoAPIModel
     */
    accountId: number;
    /**
     * 
     * @type {Date}
     * @memberof PartnerInfoAPIModel
     */
    created: Date;
    /**
     * 
     * @type {string}
     * @memberof PartnerInfoAPIModel
     */
    iconUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PartnerInfoAPIModel
     */
    iconHasNaming: boolean;
}

export function PartnerInfoAPIModelFromJSON(json: any): PartnerInfoAPIModel {
    return PartnerInfoAPIModelFromJSONTyped(json, false);
}

export function PartnerInfoAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerInfoAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'key': json['key'],
        'name': json['name'],
        'returnUrl': json['returnUrl'],
        'callbackUrl': json['callbackUrl'],
        'accountId': json['accountId'],
        'created': (new Date(json['created'])),
        'iconUrl': !exists(json, 'iconUrl') ? undefined : json['iconUrl'],
        'iconHasNaming': json['iconHasNaming'],
    };
}

export function PartnerInfoAPIModelToJSON(value?: PartnerInfoAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'key': value.key,
        'name': value.name,
        'returnUrl': value.returnUrl,
        'callbackUrl': value.callbackUrl,
        'accountId': value.accountId,
        'created': (value.created.toISOString()),
        'iconUrl': value.iconUrl,
        'iconHasNaming': value.iconHasNaming,
    };
}


